import { NavLink, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Jobs from "./pages/Jobs";
import Outreach from "./pages/Outreach";
import Searches from "./pages/Searches";
import Settings from "./pages/Settings";
import TokenGate from "./components/TokenGate";

export default function App() {
  return (
    <TokenGate>
      <div className="layout">
        <nav className="sidebar">
          <h1>JobHunter</h1>
          <NavLink to="/" end>Dashboard</NavLink>
          <NavLink to="/jobs">Jobs</NavLink>
          <NavLink to="/outreach">Outreach</NavLink>
          <NavLink to="/searches">Searches</NavLink>
          <NavLink to="/settings">Settings</NavLink>
          <div className="hint">
            Agent pipeline: harvest &rarr; enrich &rarr; draft &rarr; approve &rarr; send.
            All state lives in Cloudflare D1 via the Worker API.
          </div>
        </nav>
        <main className="content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/outreach" element={<Outreach />} />
            <Route path="/searches" element={<Searches />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </main>
      </div>
    </TokenGate>
  );
}